import { Component, Inject, OnDestroy } from '@angular/core';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ExecutionAttachment, ExecutionQAttachment } from 'src/app/model/execution';
import { GenericClass } from 'src/app/model/genericClass';
import { ProtocolAttachment } from 'src/app/model/protocol';
import { ThemeService } from 'src/app/services/theme.service';
import { GenericAttachment } from '../../../model/genericClass';

export interface DialogDataEditAttachmentEdit {
  attachment: ProtocolAttachment | ExecutionAttachment | ExecutionQAttachment | GenericAttachment;
  types: GenericClass[];
}

@Component({
    selector: 'app-edit-attachment-edit',
    templateUrl: './edit-attachment-edit.component.html',
    standalone: false,
})
export class EditAttachmentEditComponent implements OnDestroy {

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<EditAttachmentEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataEditAttachmentEdit,
    private themeService: ThemeService) {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onTypeChange(event: MatOptionSelectionChange): void {
    const idType = event.source.value as number;

    const type = this.data.types.find(t => t.id === idType);

    this.data.attachment.idType = type.id;
    this.data.attachment.nameType = type.name;
  }

  onOkClick(): void {
    this.dialogRef.close(this.data.attachment);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTheme(): string {
    return this.themeService.getTheme();
  }

}
